import regionsData from './regions-data.json';
import { useTranslation } from 'react-i18next';

export const REGIONS_DATA = regionsData;

/**
 *
 * @param {string} code a two character region code
 * @returns {Array<string>|null}
 */
export const getRegionLanguages = (code) => {
  const region = REGIONS_DATA[code];
  if (!region) return null;
  return region.languages.map((l) => l.code);
};

const useRegions = () => {
  const { i18n } = useTranslation();
  const { language } = i18n;
  const regionCode = window.location.pathname.split('/')[1];

  const getTcsLink = () => {
    const def =
      'https://www.canon.ge/get-involved/for-creators-in-all-worlds/terms-and-conditions/';
    const tcsPath = '';
    const langData = REGIONS_DATA?.[regionCode]?.languages?.find((l) => l?.code === language);
    if (!langData?.tcsDomain) return def;
    return langData?.tcsDomain + tcsPath;
  };

  const getPrivacyPolicyLink = () => {
    const def = 'https://www.canon.ge/privacy-policy/';
    const policyPath = '';
    const langData = REGIONS_DATA?.[regionCode]?.languages?.find((l) => l?.code === language);
    if (!langData?.policyDomain) return def;
    return langData?.policyDomain + policyPath;
  };

  const getCanonPageLink = () => {
    const def = 'https://www.canon.ge';
    const pagePath = '/get-involved/for-creators-in-all-worlds/';
    const langData = REGIONS_DATA?.[regionCode]?.languages?.find((l) => l?.code === language);
    if (!langData.tcsDomain) return def + pagePath;
    return langData.tcsDomain + pagePath;
  };

  const hasTransferConsentField = () => REGIONS_DATA?.[regionCode]?.transferConsent;

  const getCountryCodesAndNames = () => {
    return Object.entries(REGIONS_DATA)
      .filter(([code]) => code !== 'ce')
      .map(([code, r]) => [code, r.name]);
  };

  return {
    getTcsLink,
    getPrivacyPolicyLink,
    getCanonPageLink,
    hasTransferConsentField,
    getCountryCodesAndNames,
  };
};

export default useRegions;
